// @flow

import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import './PowerButton.scss';

type Props = {
  disabled: boolean,
  active: boolean,
  label: string,
};

export default function PowerButton(props: Props) {
  return (
    <span
      role="button"
      className={classnames('power-button', {
        disabled: props.disabled,
        active: props.active,
      })}
      aria-label={props.label}
      {..._.omit(props, ['disabled', 'active', 'className'])}
    >
      <i className="fa fa-power-off" aria-hidden="true" />
      <input
        type="checkbox"
        className="sr-only"
        checked={props.active}
        readOnly
      />
    </span>
  );
}



/** WEBPACK FOOTER **
 ** ./src/js/components/buttons/PowerButton.jsx
 **/